import React, { useContext } from 'react';
import SnackbarContext from './SnackbarContext';
var emptyFn = function () { return null; };
var withSnackbar = function (ComponentToWrap) { return function (props) {
    var _a = useContext(SnackbarContext) || {}, _b = _a.showSnackbar, showSnackbar = _b === void 0 ? emptyFn : _b, _c = _a.hideSnackbar, hideSnackbar = _c === void 0 ? emptyFn : _c;
    return <ComponentToWrap {...props} showSnackbar={showSnackbar} hideSnackbar={hideSnackbar}/>;
}; };
export default withSnackbar;
